<template>
    <!-- 问题研讨 -->
    <div class="discu-box">
        <div class="title distit">
            <div class="left">
                {{ $t('全部回复') }} ({{ dataList.cooperate_ans_list_count }})
                <el-button type="primary" @click="dialogVisibleOut=true" v-throttle="1000" :class="{'sel':sort_method==10}">
                    {{ $t('回复') }}
                </el-button>
            </div>
            <div class="right">
                <el-button type="text" @click="sort_method=10;getData()" v-throttle="1000" :class="{'sel':sort_method==10}">
                    {{ $t('按时间排序') }}
                </el-button>
                <el-button type="text" @click="sort_method=20;getData()" v-throttle="1000" :class="{'sel':sort_method==20}">
                    {{ $t('按点赞排序') }}
                </el-button>
            </div>
        </div>

        <div class="question-box">
            <template v-if="dataList.cooperate_ans_list?.length > 0">

                <div class="list" v-for="(item, index) in dataList.cooperate_ans_list" :key="index">
                    <template v-if="item.tcbaa_show_status==20">
                        <div class="notshow">
                            <span class="iconfont">&#xe66c;</span>
                            <p>{{ $t('违反社区公约，已设置为不可见') }}</p>
                        </div>
                    </template>
                    <template v-else>
                    <div class="info df aic">
                        <div @click="handleOpenavatar(item)" class="df cup">
                            <el-avatar :size="24"
                                :src="item.user_avatar_url || require('@/assets/images/avatar.png')"
                                @error="true">
                                <img src="@/assets/images/avatar.png" alt="">
                            </el-avatar>
                        </div>
                        <span class="name">{{ item.user_nick_name || $t('匿名用户') }}</span>

                            <!-- 版主评论和版主点赞 -->
                        <div class="moderator-box ml-12 df">
                            <!-- 评论 icon-pinglun      点赞 icon-dianzan_kuai  -->
                            <template v-if="item.data_is_moderator && item.tcbaa_type == 10">
                              <div class="box-1"><span class="iconfont icon-pinglun"></span></div>
                              <div class="box-2">{{ $t('管理员评论') }}</div>
                            </template>
                            <template v-if="item.data_have_be_moderator_like">
                              <div class="box-1"><span class="iconfont icon-dianzan_kuai"></span></div>
                              <div class="box-2">{{ $t('管理员点赞') }}</div>
                            </template>
                        </div>


                    </div>
                    <!-- 是否是精华帖 -->
                
                    <div class="essence-box" v-if="item.tcbaa_rec == 900">
                      <template>
                        <img :src="require('@/assets/images/essence-'+currentLanguge+'.png')" alt="">
                      </template>
                    </div>

                    <div class="desc" v-html="item.tcbaa_content"></div>


                    <div class="like-box df aic jcsb">
                        <div class="pl-36">
                            <span class="c-6 fs-14">{{ item.create_time }}</span>
                        </div>
                      <div class="df jcfe">
                        <template v-if="dataList.is_admin == 10">
                            <el-button type="text" @click="setShowHandle(item)" class="df aic" v-throttle="1000">
                                <span class="iconfont">&#xe6cf;</span>
                                <span class="hava-text">
                                    {{ $t('设置为不可见') }}
                                </span>
                            </el-button>
                            <el-button type="text" @click="handleEssence(item)" class="df aic" v-throttle="1000" :class="{ 'have_like': item.tcbaa_rec == 900 }">
                                <span class="iconfont icon-jiangbei"></span>
                                <span class="hava-text">
                                    {{ item.tcbaa_rec == 900 ? $t('取消精华评论') : $t('置为精华评论') }}
                                </span>
                            </el-button>
                        </template>

                        <el-button type="text" class="df aic" v-throttle="1000" @click="tipsHandle(item)" :disabled="item.have_tips">
                          <span class="iconfont fs-15">&#xe66c;</span>{{ item.have_tips ? $t('已举报') : $t('举报') }}
                        </el-button>

                        <el-button type="text" class="df aic" v-throttle="1000" @click="handleReplyPer(item)">
                          <span class="iconfont fs-15">&#xe60b;</span>{{ $t('回复') }}</el-button>


                        <el-button type="text" class="df aic" v-throttle="1000"
                                   :class="{ 'have_like': item.data_have_be_like }" @click="handleactQuestionLike(item)">
                          <span class="iconfont">{{ item.data_have_be_like ? '&#xe656;' : '&#xe61b;' }}</span>
                          <span class="hava-text">
                                {{ item.tcbaa_likes ? item.tcbaa_likes : $t('点赞') }}
                            </span>
                        </el-button>
                        <el-button v-if="userinfo.user_id == item.user_id" type="text" class="df aic" v-throttle="1000" @click="handleDelete(item)"
                                   :loading="item.delete_loading">
                          <span class="iconfont fs-15">&#xe622;</span>{{ $t('删除') }}
                        </el-button>
                      </div>
                    </div>

                    <div v-if="item.children.length > 0" style="padding-left:40px;">
                        <reply-list v-for="(items, indexs) in item.children" :key="indexs" :parentItem="item" :item="items" :userinfo="userinfo"
                            :handleReplyPer="handleReplyPer" :handleactQuestionLike="handleactQuestionLike" :tipsHandle="tipsHandle"
                            :setShowHandle="setShowHandle" :handleEssence="handleEssence" :handleDelete="handleDelete"
                                    :is_moderator="dataList.is_admin" />
                    </div>
                    </template>
                </div>

            </template>
            <div class="no_news df fdc jcc aic" v-else>
                <img src="@/assets/images/no_news.png" alt="">
                <p>{{ $t('暂无消息') }}</p>
            </div>
        </div>

        
        <el-dialog :title="$t('回复')" :visible.sync="dialogVisibleOut" @close="handleClose" width="570px">
            <div class="df reply-person">
                <span class="fn mr-16 c-9 fs-14">{{ $t('回复') }}</span>
                <!-- <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入您的回复')"
                    v-model="textareaper"></el-input> -->
                <Editor :allFunctions="false" v-model="textarea" :height="300" :isUseOss="true" />
            </div>
            <div class="languige-text harmonyos-text mt-24" v-if="userinfo.user_expert == 10 && false">
                {{ $t('以实名身份发布') }}
                <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">
                    <span class="iconfont">&#xe677;</span>
                </el-tooltip>
                <el-checkbox-group v-model="is_expert" style="display: inline-block;" class="ml-23">
                    <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>
                </el-checkbox-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" class="btn1">{{ $t('取消') }}</el-button>
                <el-button type="primary" class="btn2" :loading="replyLoading" @click="handleReply">{{ $t('确定') }}</el-button>
            </span>
        </el-dialog>

        <el-dialog :title="$t('回复')" :visible.sync="dialogVisible" @close="handleClose" width="570px">
            <div class="df reply-person">
                <span class="fn mr-16 c-9 fs-14">{{ $t('回复') }}</span>
                <!-- <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 10 }" :placeholder="$t('请输入您的回复')"
                    v-model="textareaper"></el-input> -->
                <Editor :allFunctions="false" v-model="textareaper" :height="300" :isUseOss="true" />
            </div>
            <div class="languige-text harmonyos-text mt-24" v-if="userinfo.user_expert == 10 && false">
                {{ $t('以实名身份发布') }}
                <el-tooltip :content="$t('以专家身份实名评论后页面会同步展示实名信息')" placement="bottom-start" effect="light">
                    <span class="iconfont">&#xe677;</span>
                </el-tooltip>
                <el-checkbox-group v-model="is_expert" style="display: inline-block;" class="ml-23">
                    <el-checkbox :key="10" :label="10">{{ $t('是') }}</el-checkbox>
                </el-checkbox-group>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" class="btn1">{{ $t('取消') }}</el-button>
                <el-button type="primary" class="btn2" :loading="replyLoading" @click="handelSubPer">{{ $t('确定') }}</el-button>
            </span>
        </el-dialog>


        <!-- 个人信息 -->
        <avatarTop ref="avatarDialog" @post-submitted="handleAvatarSubmitted" :id="ac_id" />

    </div>
</template>

<script>
import {getAnsList, tips, setShow, setAnsEssence, ansLike, ansAdd, ansDelete} from '@api/cooperate';
import { getMyInfo, setuserfollowAdd } from "@api/home";
import replyList from "./replyList.vue";
import Editor from '@/components/Editor/index.vue';

export default {
    components: {
        replyList,
        Editor
    },
    props: {
        tcb_id: {
            type: [String, Number],
            required: true
        },
        id: {
            type: [String, Number],
            required: true
        },
        data: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            currentLanguge: localStorage.getItem('currentLanguage') || 'zh',
            dialogVisible: false,  //回复弹框
            dialogVisibleOut: false,
            cooperate_ans_list_count:0,
            dataList: {},
            userinfo: [],
            textarea: '',
            textareaper: '',  //回复别人的评论
            is_expert: [10],  //回复别人的评论
            personObj: {},

            ac_id: 0,
            replyLoading: false,
            sort_method: 10,
        }
    },
    watch: {
        data: {
            handler(newData) {
                this.dataList = this.data;
            },
            deep: true, // 如果需要深度监听数组中的对象变化，可以设置为 true
            immediate: true // 如果希望在组件创建时立即执行一次 handler
        }
    },

    mounted() {
        this.dataList = this.data;
        this.getCurrUserData();
    },
    methods: {
        async handleDelete(item) {
          this.$nextTick(() => {
            item.delete_loading = true;
          })
          let res = await ansDelete({ tcbaa_id: item.tcbaa_id });
          if (res.status == 200) {
            this.$message({
              message: res.msg,
              type: 'success',
              customClass: 'mt-60' // 添加自定义类
            });
          }
          await this.getData();
        },
        // 置精华
        async handleEssence(item) {
            const res = await setAnsEssence({ 
                tcb_id: this.tcb_id,
                tcba_id: this.id,
                tcbaa_id: item.tcbaa_id,
            });
            if (res.status == 200) {
                this.$message.success(res.msg);
                await this.getData();
            }
        },
        // 设置不可见
        async setShowHandle(item) {
            const res = await setShow({ 
                tcb_id: this.tcb_id,
                tcbaa_id: item.tcbaa_id,
            });
            if (res.status == 200) {
                this.$message.success(res.msg);
                await this.getData();
            }
        },
        errorHandler() {
            return true
        },
        async getCurrUserData() {
            let res = await getMyInfo();
            if (res.status == 200) {
                this.userinfo = res.data;
            }
        },

        handleOpenavatar(item) {
            if (item.user_id == 0 || item.user_id == null || item.user_nick_name == 0 || item.user_nick_name == null) {
                return false;
            }
            this.ac_id = item.user_id;
            this.$refs.avatarDialog.openModal();
            // 
        },
        // 个人信息谈款
        async handleAvatarSubmitted(id) {

            let res = await setuserfollowAdd({ tuf_be_follow_user_id: id });
            if (res.status == 200) {
                this.$message.success(res.msg);

            }

        },

        async getData() {
            let res = await getAnsList({ id: this.id,sort_method:this.sort_method });
            this.dataList = res.data;
        },
        // 点赞
        async handleactQuestionLike(item) {
            let res = await ansLike({ tcbaa_id: item.tcbaa_id });
            if(res.status==200){
                this.$message.success(res.msg)
                await this.getData();
            }else{
                this.$message.error(res.msg)
            }
        },
        // 举报
        tipsHandle(item){
            this.$confirm(this.$t("确定举报这条评论吗?"), this.$t("提示"), {
				confirmButtonText: this.$t("确定"),
				cancelButtonText: this.$t("取消"),
				type: "warning",
			}).then(async()=>{
				const res = await tips({
					tcb_id:this.tcb_id,
					tcbaa_id:item.tcbaa_id
				})
				if(res.status == 200) {
					this.$message.success(res.msg);
					this.getData();
				}
			})
        },

        handleReply() {
            let obj = { 
                tcba_id: this.id,
                tcbaa_content: this.textarea,
                tcbaa_pid: 0,
                to_user_id: "",
                is_expert: this.userinfo.user_expert
            };
            this.replyPostAns(obj);
            this.handleClose()
        },
        // 关闭回复
        handleClose(){
            this.dialogVisible = false;
            this.dialogVisibleOut = false;
            setTimeout(() => {
                this.textareaper = '';
                this.textarea = '';
                this.is_expert = [10];
            }, 200);
        },
        handelSubPer() {
            let obj = { 
                tcba_id: this.id,
                tcbaa_content: this.textareaper,
                tcbaa_pid: this.personObj.tcbaa_id,
                to_user_id: this.personObj.user_id, 
                is_expert: this.userinfo.user_expert
            };
            this.replyPostAns(obj);
            this.handleClose()
        },

        // 回复评论
        handleReplyPer(item) {
            this.dialogVisible = true;
            this.personObj = item;
        },
        // 评论
        async replyPostAns(obj) {
            this.replyLoading = true;
            let res = await ansAdd(obj);

            if (res.status == 200) {
                this.$message({
                    message: res.msg,
                    type: 'success',
                    customClass: 'mt-60' // 添加自定义类
                });
            }
            this.getData();
            this.replyLoading = false;
        },
    }
}
</script>


<style lang="scss" scoped>
.essence-box {
    position: absolute;
    right: 24px;
    top: -10px;
}
.moderator-box {
    height: 23px;
    line-height: 22px;

    .box-1 {
        // 背景渐变FFA547
        background: linear-gradient(180deg, #FF8B29 0%, #FFA547 100%);
        // background: #FF8E2D;
        padding: 0 16px 0 6px;
        border-radius: 8px 0 0 0;

        .iconfont {
            font-size: 14px;
            position: relative;
            top: -1px;
            color: #ffffff;
        }
    }

    .box-2 {
        background: #FAEAD7;
        position: relative;
        left: -10px;
        color: #FF8E2D;
        font-size: 12px;
        padding: 0 10px;
        border-radius: 12px 0 8px 0;
        border-left: 1px solid #ffffff;
    }
}
.list {
    margin-top: 16px;
    position: relative;

    .notshow{
        text-align: center;
        padding: 30px;
        font-size: 14px;
        color: #666;
        span{
            color: #D64F31;
            font-size: 20px;
        }
    }
    .info {
        color: rgb(25, 25, 25);
        font-size: 16px;
        font-weight: 400;
        line-height: 22px;

        .name {
            margin-left: 12px;
            font-family: "MicrosoftYaHeiSemibold";
        }
    }

    .desc {
        margin-left: 36px;
        color: rgb(25, 25, 25);
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        margin-top: 14px;
        ::v-deep a{
            color: #00e;
        }
    }

    .like-box {
        margin-top: 8px;

        .hava-text {
            min-width: 28px;
            display: inline-block;
            text-align: left;
        }

        button {
            color: rgb(174, 174, 174);
            font-size: 14px;
            font-weight: 400;
            line-height: 22px;
            padding: 0 8px;

            &.have_like {
                color: rgb(216, 15, 5);
                ;
            }

            img,
            .iconfont {
                width: 16px;
                margin-right: 8px;
            }

            &:hover {
                color: rgb(216, 15, 5);
                ;

            }
        }

        .el-button+.el-button {
            margin-left: 0;
        }
    }
}

::v-deep() {
    .el-dialog__body {
        padding: 12px 20px 16px;
    }

    .el-dialog {
        border-radius: 8px;
    }

    .dialog-footer {

        .btn1,
        .btn2 {
            min-width: 75px;
            height: 36px;
            border-radius: 30px;
            padding: 0 16px;
        }

        .btn1 {
            background-color: #ffffff;
            border: 1px solid #ededed;
        }

        .btn2 {
            background-color: #D64F31;
            border: none;
        }

        .el-button+.el-button {
            margin-left: 24px;
        }
    }

}

.reply-person {
    background-color: #F8F8F8;
    padding: 16px;
    border-radius: 4px;

    ::v-deep() {
        .el-textarea__inner {
            border: none;
            padding: 0;
            background-color: transparent;
        }
    }
}

.reply-box {
    min-height: 88px;
    border: 0.5px solid rgb(201, 201, 201);
    border-radius: 8px;
    margin-top: 14px;
    margin-left: 36px;
    padding: 8px 20px 8px 12px;

    ::v-deep() {
        el-textarea {
            height: 100%;

        }

        .el-textarea__inner {
            border: none;
            min-height: 72px !important;

            &::-webkit-scrollbar {
                width: 0;
            }
        }
    }
}

.question-box {
    margin-top: 24px;

    // min-height: 310px;

    .no_news {
        height: 310px;

        p {
            color: rgb(119, 119, 119);

            font-size: 14px;
            font-weight: 400;
            line-height: 24px;
            margin-top: 4px;
        }
    }

}

.discu-box {
    padding-top: 40px;
    padding-bottom: 80px;

    .title {
        color: rgb(25, 25, 25);
        font-size: 20px;
        font-weight: 400;
        line-height: 30px;
        font-family: "MicrosoftYaHeiSemibold";
    }
    .distit{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left{
            .el-button{
                height: 36px;
                padding: 0 20px;
                margin-left: 20px;
            }
        }
        .right .el-button{
            color: #333;
            &.sel{
                color: #D64F31;
            }
        }
    }
}
</style>